import { Helpers } from '../../helpers';
import { ICalendar } from '../../interfaces/icalendar';
import { ScheduleActivity } from '../schedule-activity';

export class CalendarBase {
  CalendarId: number;
  Name: string;
  P6CalendarObjectId: number;
  IsDefault: boolean | null;
  HoursPerDay: number;
  HoursPerWeek: number;
  HoursPerMonth: number | null;
  HoursPerYear: number;
  IsPersonal: boolean;
  CalendarType: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  P6ProjectId: number | null;
  P6ProjectObjectId: number | null;
  RecievedByP6: Date | null;

  ScheduleActivities_Calendar?: Array<ScheduleActivity> | null;

  constructor(item?: ICalendar) {
    if (item) {

      this.CalendarId = item.CalendarId;
      this.Name = item.Name;
      this.P6CalendarObjectId = item.P6CalendarObjectId;
      this.IsDefault = item.IsDefault;
      this.HoursPerDay = item.HoursPerDay;
      this.HoursPerWeek = item.HoursPerWeek;
      this.HoursPerMonth = item.HoursPerMonth;
      this.HoursPerYear = item.HoursPerYear;
      this.IsPersonal = item.IsPersonal;
      this.CalendarType = item.CalendarType;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.P6ProjectId = item.P6ProjectId;
      this.P6ProjectObjectId = item.P6ProjectObjectId;
      this.RecievedByP6 = item.RecievedByP6 ? new Date(item.RecievedByP6) : null;

      this.ScheduleActivities_Calendar = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_Calendar);
    }
  }
}